export default "__VITE_ASSET__CZ3s$iXI__"